import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

import { filterSignalTypes } from "../../utils/filterSignalTypes";

export const useSignalTypesOptions = () => {
    return useMemo(
        () =>
            filterSignalTypes(Object.values(SignalType)).map((signalType) => ({
                id: signalType,
                text: translate(`si.signals.group.${signalType}.text.compact`),
            })),
        [],
    );
};
